import styled from 'styled-components';

export const WhyPartnerVideoBlock = styled.div(
    props => `
        width:48.8rem;
        height: 30rem;
        display: flex;
        align-items: center;
        justify-content: center;

        @media(max-width:1023px){
          width:100%;
          height:25rem;
        }
    `
);

export const VideoWrapper = styled.div(
    props => `
      width: 100%;
      display: flex;
      justify-content: center;
      height: 30rem;
      margin: 0;
      z-index:1;
      position: relative;
  
      @media only screen and (min-width:320px) and (max-width: 767px){
        height: 23rem;
        margin: 0;
      }
  
      @media only screen and (min-width:768px) and (max-width: 1024px){
        height: 30rem;
      }
  
      @media only screen and (min-width:1025px) and (max-width: 1300px){
        height: 30rem;
      }
    `
);
  
export const VideoSelectWrap = styled.div(
    props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top:0;
      left:0;
      bottom:0;
      right: 0;
      z-index: 1;
      background-color: rgba(0,0,0,0.5);
      flex-direction: column;
      border-radius: 1.6rem;
    `
);

export const VideoInnerWrap = styled.div(
    props => `
      width: 57rem;
      position:relative;
      border-radius: 16px;
      display: flex;
      @media only screen and (min-width:320px) and (max-width: 767px){
        width:38rem;
      }
    `
);

export const SelectHeadText = styled.p(
    props => `
      font-size: ${props.theme.font.large.font20};
      font-weight: ${props.theme.font.fontWeight.bold};
      color: ${props.theme.colors.white.base};
    `
);
  
export const SelectOptionList = styled.ul(
    props => `
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin-top: ${props.theme.spacing.large.l20};
  
      li{
        display: flex;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
        background-color: ${props.theme.colors.grey.lighte7};
        border-radius: 0.4rem;
        margin-right: ${props.theme.spacing.base};
        margin-bottom: ${props.theme.spacing.base};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        cursor: pointer;
      }
    `
);

  